import { CssBaseline, ThemeProvider } from '@mui/material';
import { LicenseInfo } from '@mui/x-license';
import type { ReactNode } from 'react';
import { theme } from '../theme';

let licenseSet = false;

export interface VyThemeProviderProps {
  children: ReactNode;
  /**
   * MUI X license key. Optional — if the consumer already calls
   * `LicenseInfo.setLicenseKey` elsewhere in the app boot, omit this.
   */
  licenseKey?: string;
  /**
   * If true, applies `<CssBaseline />` inside the provider. Default false
   * because the host app usually has its own at the root.
   */
  withCssBaseline?: boolean;
}

/**
 * Provides the design system theme to all descendants.
 * Wraps MUI's `ThemeProvider` with the canonical theme.
 */
export function VyThemeProvider({
  children,
  licenseKey,
  withCssBaseline = false,
}: VyThemeProviderProps) {
  if (licenseKey && !licenseSet) {
    LicenseInfo.setLicenseKey(licenseKey);
    licenseSet = true;
  }

  return (
    <ThemeProvider theme={theme}>
      {withCssBaseline ? <CssBaseline /> : null}
      {children}
    </ThemeProvider>
  );
}
